<template>
  <div class="tx-footer">
    <div v-html="content"></div>
  </div>
</template>
<script setup>
import config from '@img/config.json';
import px2vw from '@/utils/px2vw_v2';

import { get_copyright } from '@utils/api';

const props = defineProps({
  src: {
    type: String,
    required: false,
  },
  name: {
    type: String,
    required: false,
  },
});

const bg = computed(() => {
  let src = config[props.src].src;
  return `${src}.${support_image.value}`;
});
const computedStyle = computed(() => {
  const size = config[props.src];

  return {
    backgroundImage: `url(${bg.value})`,
    backgroundRepeat: 'round',
    width: px2vw(size.width, is_mobile.value),
    height: px2vw(size.height, is_mobile.value),
  };
});

const content = ref('');

onMounted(async () => {
  // let src = config[props.src].src;
  // bg.value = `${src}.${support_image.value}`;
  // get_copyright().then((res) => {
  //   console.log("get_copyright", res)
  // })

  $.ajax({
    url: 'https://websource.nie.netease.com/copyright/get/byreferer',
    dataType: 'jsonp',
    data: {
      type: 'm',
      // browserversion: a,
      domain: nie.config.copyRight.domain || '',
      showmore: nie.config.copyRight.showmore || 0,
    },
    success: function (n) {
      console.log('get_copyright', n);
      
      if (n.success) {
        if (!n.result || !n.result.copyright) return !1;
        content.value = n.result.copyright.replace(
              /(\/images\/([^\.\/]*)\.)\d{1}(\.png)/gi,
              '$12$3'
            );
      //   e(function () {
      //     2 == nie.config.copyRight.getStyle() &&
            // (n.result.copyright = n.result.copyright.replace(
            //   /(\/images\/([^\.\/]*)\.)\d{1}(\.png)/gi,
            //   '$12$3'
            // )),
      //       c(n.result.copyright);
      //   }),
      //     n.result.browsertips &&
      //       0 == o.length &&
      //       r > 1e3 &&
      //       !s &&
      //       e('body').prepend(n.result.browsertips);
      // } else {
      //   var i = n.msg || n.errmsg;
      //   c(t, '\u7248\u6743\u52a0\u8f7d\u5931\u8d25\uff1a' + i);
      }
    },
    // error: function (e) {
    //   c(t, '\u7248\u6743\u52a0\u8f7d\u5931\u8d25\uff1a' + JSON.stringify(e));
    // },
  });
});
</script>

